var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.privileged
    ? _c(
        "div",
        { staticClass: "payouts" },
        [
          _vm.canRequestPayout
            ? _c(
                "vs-container",
                {
                  attrs: {
                    "hide-date": "hide-date",
                    "hide-search": "hide-search",
                    "button-hidden": "button-hidden",
                    tabs: _vm.tabs,
                    "active-tab": _vm.$route.matched[2].name
                  },
                  on: {
                    "change-tab": function($event) {
                      return _vm.$router.push({ name: $event })
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "payouts__container" },
                    [_c("router-view")],
                    1
                  ),
                  _c("payment-modals"),
                  _c("deductions-modal", {
                    on: { close: _vm.handleCloseDeductionsModal }
                  })
                ],
                1
              )
            : _c("request-payout-instructions")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }